import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const warehousemanagersAdapter = getAdapter();
const warehousemanagersSlice = createSlice({
  name: 'warehousemanagers',
  initialState: warehousemanagersAdapter.getInitialState(),
  reducers: {
    setWarehouseManagers: (state, { payload: { warehousemanagers } }) => {
      warehousemanagersAdapter.setAll(state, warehousemanagers);
    }
  }
});

const selectors = warehousemanagersAdapter.getSelectors(({ warehousemanagers }) => warehousemanagers);

export const getWarehouseManagersIncludingDeleted = state => selectors.selectAll(state);

export const getWarehouseManagers = state => getWarehouseManagersIncludingDeleted(state).filter(({ active }) => active);

export const { setWarehouseManagers } = warehousemanagersSlice.actions;

export default warehousemanagersSlice.reducer;
